export default class UserEvent {
  constructor(public title: string, public date: Date = new Date()) {}

  public get formattedTime() {
    return this.date.toLocaleTimeString(navigator.language, {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  public get formattedDate() {
    return this.date.toLocaleDateString(navigator.language, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
  }
}
